exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".case-study__maje{font-size:30px}.case-study__maje .case-study__photo-background{background-color:#313596}.case-study__maje .case-study__photo{margin-top:100px}.case-study__maje .case-study__section{margin-top:10em;margin-bottom:6em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-d51ccd80!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/CaseStudy/Maje.vue
// module id = 130
// module chunks = 0